import {type ModalPage} from '../models/IEnvironment';
import {store} from '../store';
import {startModalLoading, stopModalLoading, updateEnvironment} from '../reducers/environmentReducer';
import {checkRequiredFields} from './additionalFields';
import {PeachPayCustomer, updateCustomerFields} from '../reducers/peachPayCustomerReducer';
import {updateCustomerAddressValidation} from '../reducers/peachPayOrderReducer';
import {requestCartCalculation} from '../payment/order';
import {$qs} from '../../../@shared/ts/dom';
import {renderCustomerFields} from './customer';

export function renderModalNavigation(modalPage: ModalPage) {
	if (modalPage === 'info') {
		$qs('#pp-exit-mobile')?.classList.remove('hide');
		$qs('#pp-back-to-info-mobile')?.classList.add('hide');
		$qs('#pp-back-to-shipping-mobile')?.classList.add('hide');
	} else if (modalPage === 'shipping') {
		$qs('#pp-exit-mobile')?.classList.add('hide');
		$qs('#pp-back-to-info-mobile')?.classList.remove('hide');
		$qs('#pp-back-to-shipping-mobile')?.classList.add('hide');
	} else if (modalPage === 'payment') {
		$qs('#pp-exit-mobile')?.classList.add('hide');
		$qs('#pp-back-to-info-mobile')?.classList.add('hide');
		$qs('#pp-back-to-shipping-mobile')?.classList.remove('hide');
	}
}

export function renderModalPageIndicator(
	modalPage: ModalPage,
): void {
	// Show/hide info page indicator
	if (modalPage === 'info') {
		$qs('#pp-checkout-status-left')?.classList.add('current');
		$qs('#pp-checkout-status-left-text')?.classList.add('hide');
		$qs('#pp-checkout-status-middle')?.classList.remove('current');
		$qs('#pp-checkout-status-middle')?.classList.add('no-fill');
		$qs('#pp-checkout-status-middle')?.removeEventListener('click', backToShipping);
		$qs('#pp-checkout-status-middle-text')?.classList.add('hide');
		$qs('#pp-checkout-status-right')?.classList.remove('current');
		$qs('#pp-checkout-status-right')?.classList.add('no-fill');
		$qs('#pp-checkout-status-right')?.removeEventListener('click', shippingToPayment);
	} else if (modalPage === 'shipping') {
		$qs('#pp-checkout-status-left')?.classList.remove('current');
		$qs('#pp-checkout-status-left-text')?.classList.remove('hide');
		$qs('#pp-checkout-status-middle')?.classList.remove('no-fill');
		$qs('#pp-checkout-status-middle')?.classList.add('current');
		$qs('#pp-checkout-status-middle')?.removeEventListener('click', backToShipping);
		$qs('#pp-checkout-status-middle-text')?.classList.add('hide');
		$qs('#pp-checkout-status-right')?.classList.remove('current');
		$qs('#pp-checkout-status-right')?.classList.add('no-fill');
		// This prevents the #pp-info-form from getting submitted
		$qs('#pp-checkout-status-right')?.addEventListener('click', shippingToPayment);
	} else if (modalPage === 'payment') {
		$qs('#pp-checkout-status-left')?.classList.remove('current');
		$qs('#pp-checkout-status-left-text')?.classList.remove('hide');
		$qs('#pp-checkout-status-middle')?.classList.remove('current');
		$qs('#pp-checkout-status-middle')?.classList.remove('no-fill');
		// This prevents the #pp-info-form from getting submitted
		$qs('#pp-checkout-status-middle')?.addEventListener('click', backToShipping);
		$qs('#pp-checkout-status-middle-text')?.classList.remove('hide');
		$qs('#pp-checkout-status-right')?.classList.add('current');
		$qs('#pp-checkout-status-right')?.classList.remove('no-fill');
		$qs('#pp-checkout-status-right')?.removeEventListener('click', shippingToPayment);
	}

	$qs('#pp-checkout-status-left')?.addEventListener('click', backToInfo);
}

function shippingToPayment(event: Event): void {
	dispatchRequestedPage('payment');
	event.preventDefault();
	if (checkRequiredFields()) {
		store.dispatch(updateEnvironment({
			modalPageType: 'payment',
			requestedPage: undefined,
		}));
	}

	$qs('.pp-close')?.scrollIntoView();
}

export function continueToPayment(): void {
	dispatchRequestedPage('payment');
	if (checkRequiredFields()) {
		store.dispatch(updateEnvironment({
			modalPageType: 'payment',
			requestedPage: undefined,
		}));
	}

	$qs('.pp-close')?.scrollIntoView();
}

export function backToInfo(): void {
	store.dispatch(updateEnvironment({
		modalPageType: 'info',
	}));
	store.dispatch(updateCustomerAddressValidation(false));
	$qs('.pp-close')?.scrollIntoView();
}

export async function backToShipping(event: Event, shipToDifferentAddress = false): Promise<void> {
	event.preventDefault();
	store.dispatch(updateCustomerAddressValidation(false));
	if (shipToDifferentAddress) {
		renderCustomerFields(PeachPayCustomer.data(), 'info');

		const formFields = PeachPayCustomer.data().form_fields;
		formFields['ship_to_different_address'] = '1';
		store.dispatch(updateCustomerFields(formFields));
		$qs<HTMLInputElement>(
			'#pp-continue-to-payment',
			$element => {
				$element.disabled = true;
			},
		);
		$qs('#pp-refresh-shipping-options', $element => {
			$element.style.display = 'block';
		});
		store.dispatch(startModalLoading());
		await requestCartCalculation();
		store.dispatch(stopModalLoading());
	}

	store.dispatch(updateEnvironment({
		modalPageType: 'shipping',
	}));
	$qs('.pp-close')?.scrollIntoView();
}

export function dispatchRequestedPage(page: ModalPage) {
	store.dispatch(updateEnvironment({
		requestedPage: page,
	}));
}
